/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    // For the contentarea where option to display links as buttons is ticked add the btn class
    if (el.closest(".linksasbtns")) {
      // el.classList.add('btn');
      return;
    }
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();

window.addEventListener("load", linksInit);

/*  ==========================================================================
		GENERAL: Separate letters in button text to create hover effect
		========================================================================== */

const btnsInit = function () {
  const btns = document.querySelectorAll(".btn:not(.nf-fu-fileinput-button), .linksasbtns a, .sidebar__link");
  btns.forEach(function (el) {
    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector(".btn__textwrap") < 1) {
      const btnHTML = "<span class='btn__textwrap'><span class='btn__text'>" + el.textContent.trim() + "</span></span>";
      el.innerHTML = btnHTML;
      let clone = el.querySelector(".btn__text").cloneNode(true);

      el.querySelector(".btn__textwrap").appendChild(clone);

      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".btn__textwrap").before(icon);
        } else {
          el.querySelector(".btn__textwrap").after(icon);
        }
      }
    }

    el.querySelectorAll(".btn__text").forEach(function (item) {
      // Change spaces for &nbsp
      let itemHTML = item.innerHTML.trim();

      item.innerHTML = itemHTML.replace(/\s/g, "&nbsp;");
      // Run lettering js
      let lettering = new Lettering(".btn__text");
      lettering.letters();
    });
  });
};

if (!isTouchDevice && !isMobile) {
  window.addEventListener("load", btnsInit);
}

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
window.addEventListener("load", sharingLinksInit);

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
    })
  );

  accordionItems.forEach(item => {
    $(item).waypoint({
      handler: function (direction) {
        if (direction === "down" && item.closest(".accordion__item").classList.contains("accordion__item--open")) {
          item.closest(".accordion__item").classList.add("stuck");
        } else {
          item.closest(".accordion__item").classList.remove("stuck");
        }
      },
      offset: 0
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyr = el.querySelector(".mediavideo__video");
    new Plyr(plyr, {
      controls: ["play", "progress", "mute", "current-time"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink:not(.sociallink--pinterest)");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();

window.addEventListener("load", socialLinksInit);

/*  ==========================================================================
    GENERAL - Fancybox Inspiration
    ========================================================================== */

function setupFancyboxEvents() {
  // Adding a click event to the Inpiration tile heading. This is so the fancybox slide it's not duplciated when navigating as a gallery
  const inspirationlinks = document.querySelectorAll(".inspirationlink");

  inspirationlinks.forEach(link => {
    link.addEventListener("click", function () {
      let tile = link.closest(".tile");
      tile.querySelector(".tile__link").click();
    });
  });

  const fancyboxClose = document.getElementById("fancynavigation__close");
  const fancyboxNext = document.getElementById("fancynavigation__next");
  const fancyboxPrev = document.getElementById("fancynavigation__prev");
  const fancyNavigation = document.getElementById("fancynavigation");

  fancyboxClose.addEventListener("click", function () {
    Fancybox.close();
  });

  fancyboxPrev.addEventListener("click", function () {
    Fancybox.prev();
  });

  fancyboxNext.addEventListener("click", function () {
    Fancybox.next();
  });

  Fancybox.bind("[data-fancybox]", {
    Hash: false, // the hash plugin wasn't working breaking the page on reload
    Thumbs: {
      autoStart: false
    },
    Carousel: {
      friction: 0.8
    },
    on: {
      shouldClose: fancybox => {
        fancyNavigation.classList.remove("show");
      },
      done: (fancybox, slide) => {
        let thisContent = slide.$el;
        fancyNavigation.classList.add("show");

        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();

        const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");
        // gridCarouselInit(gridCarousels);

        // Setup up carousels inside the fancybox
        const inspirationCarousel = gridCarousels;
        if (inspirationCarousel) {
          $(inspirationCarousel).owlCarousel({
            autoplay: true,
            autoplayTimeout: 4000,
            loop: true,
            nav: false,
            dots: true,
            items: 1,
            lazyLoad: true,
            autoHeight: true,
            animateOut: "fadeOut",
            animateIn: "fadeIn"
          });
        }

        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones

        // Re setup on any links within the fancybox!
        setupFancyboxEvents();
      }
    }
  });
}

window.addEventListener("load", setupFancyboxEvents);

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

    // const loadmoreBtn = document.querySelector(".paging__loadmore");
    const loadmoreBtn = document.querySelector(".paging__loadmorebtn");
    
    const loadmoreContainer = document.querySelector(".loadmore-container");


    const loadmoreLoadPostsMultiplePages = function (pages) {
  
      if(pages && pages > 1){

        //Stopping default scroll back to previous position
        history.scrollRestoration = 'manual';

        const currentPage = new URL(window.location);
    
        //Creating an array on page numbers to map it
        var list = [];
        for (var i = 1; i < pages; i++) {
          list.push(i);
        }
    
        // Initialising the array of posts pages
        var postsHTML = [];

        // document.querySelector(".filtering-wrapper").classList.add("filtering");

        loadmoreBtn.classList.add("loading");

        // Array of ajax calls
        var allAJAX = list.map(function(page){
            const data = {
              action: "loadmore",
              query: php_variables.posts, // that's how we get params from wp_localize_script() function
              page: page
            };
            //Updating the url to mtch the page number
            currentPage.searchParams.set('pagenum', page);
            return $.ajax({
              url: php_variables.ajax_url, // AJAX handler
              data: data,
              type: "POST",
              success: function (data) {
                postsHTML[page] = data;
              }
            });
        });

        // Waiting for all the ajax calls to be finished before proceeding
        Promise.all(allAJAX).then(function() {
          // Update current page variable
          php_variables.current_page = pages;

          loadmoreBtn.classList.remove("loading");
          // document.querySelector(".filtering-wrapper").classList.remove("filtering");

          // Adding the new tiles to the dom
          list.map(page => {
            if(postsHTML[page]){
                loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
              }
          });
          const nextPage = new URL(window.location);
          nextPage.searchParams.set('pagenum', parseInt(pages) + 1);

          loadmoreBtn.href = nextPage;

          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            loadmoreBtn.style.display = "none";
          }
            
           // Re-init lazy load
           lazyLoadInstance.update(); // reinit lazy load after clones
           // Re-init effects
           const effects = document.querySelectorAll(".effect");
           effectsInit(effects);

          // Scrolling the page to the last known position
          if(localStorage.scrollPosition) {
            window.scroll({
              top: parseInt(localStorage.getItem("scrollPosition"), 10),
              behavior: "smooth"
            });
          }
         
        });
      }
    };
    
    const loadmoreLoadPosts = function (e) {

      e.preventDefault();
    
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: php_variables.current_page
      };
      let buttonText; // create variable to store button text
    
      // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
      $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          loadmoreBtn.classList.add("loading");
        },
        success: function (data) {
          if (data) {
            loadmoreBtn.classList.remove("loading"); // set back to previous button text
            loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
            
            php_variables.current_page++;

            // Only push state to set the last page number or if there is more pages to load
            const currentPage = new URL(window.location),
                  nextPage = new URL(window.location);
           
            if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
              currentPage.searchParams.set('pagenum', php_variables.current_page);
              history.pushState({}, "", currentPage);

              nextPage.searchParams.set('pagenum', php_variables.current_page + 1);

              loadmoreBtn.href = nextPage;
            }
    
            // if last page, remove the button..
            if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
              loadmoreBtn.style.display = "none";
            }
            // Re-init links to make sure linklines on newly loaded content still work
            linksInit();
            // Re-init lazy load
            lazyLoadInstance.update(); // reinit lazy load after clones
            // Re-init effects
            const effects = document.querySelectorAll(".effect");
            effectsInit(effects);
            
          } else {
            loadmoreBtn.style.display = "none"; // if no data, remove the button as well
          }
        }
      });
    }; // loadmoreLoadPosts();
    
    const loadmoreInit = function () {
      if (!loadmoreBtn) {
        return;
      }
      // Saving the scroll position before unload
      window.addEventListener("unload", function(e) {
        var scrollPosition = window.pageYOffset;
        localStorage.setItem("scrollPosition", scrollPosition);
      });
     
      loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
    }; // loadmoreInit();
    loadmoreInit();
    
    /*  ==========================================================================
    AJAX - AJAX work filter
    ========================================================================== */

const filters = document.querySelector(".filters"),
  filtersToggle = document.querySelector(".filters__toggle"),
  filterSearchToggle = document.querySelector(".filters__search__toggle"),
  filterSearch = document.querySelector(".filters__search"),
  filterSearchClear = document.querySelector(".filters__search__clear"),
  filterSearchInput = document.querySelector(".filters__search__input input"),
  filterForm = document.querySelector(".filters__form");

const filterPageURL = filters ? filters.dataset.url : "";

let filtersInitialLoad = true;

// Get current from filters data
const filterGetFormData = function () {

  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");

    if(checkedOptions.length > 0){  
      filter_data[el.name] = [...checkedOptions].map(x => x.value);
    }
  });

  return filter_data;
};

const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter_" + key + "=" + values;
    }
  }

  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;
  window.history.pushState({ path: newUrl }, "", newUrl);

};

// Toggles All Content checkbox if there is selected filters within the group
const filterSelectedAllCheckboxes = function (groupName) {
  let noActiveFiltersInGroup = true;

  document.querySelectorAll('input[type="checkbox"][name=' + groupName + "]").forEach(el => {
    if (el.checked === true) {
      noActiveFiltersInGroup = false;
    }
  });
  const allGroupCheckbox = document.querySelector('input[type="checkbox"][name=all_' + groupName + "]");
  if (allGroupCheckbox) {
    allGroupCheckbox.checked = noActiveFiltersInGroup;
  }
};

// Setup up the active tags in the filter bar
const filterAddingActiveTags = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const fieldsetField = document.querySelectorAll(".filters__fieldset__field");
  fieldsetField.forEach(field => {
    field.classList.remove("filters__fieldset__field--active");
  });

  // Reset tags
  document.querySelector(".filters__tags").classList.remove("filters__tags--active");
  document.querySelector(".filters__activetags__tags").innerHTML = "";

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document
        .querySelector(".filters__fieldset[data-value='" + key + "']")
        .classList.remove("filters__fieldset--active");

      for (const value of values) {
        // Make input field active

        let filter_input = document
          .querySelector("input[name='" + key + "'][value='" + value + "']")
          .closest(".filters__fieldset__field");

        filter_input.classList.add("filters__fieldset__field--active");
        // Show active tags
        document.querySelector(".filters__tags").classList.add("filters__tags--active");
        // Add tag
        let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;

        document.querySelector(
          ".filters__activetags__tags"
        ).innerHTML += `<div class="filters__tag btn btn--white" data-name="${key}" data-value="${value}">${filter_input_name} <i class="fas fa-times"></i></div>`;

        hasClassActive = true;
      }
    }

    filterSelectedAllCheckboxes(key);
  }

  return hasClassActive;
};

const filterGetPosts = function (updateURL) {

  // Getting the forma data
  let filterData = filterGetFormData();
  let searchData = false;
  let pageData = false;
	
	if (filterSearch && filterSearchInput) { 
		searchData = filterSearchInput.value;
	}

  let currentPageInput = document.querySelector("input.filters__currentpage");
  let currentPageNum = false;

  if (currentPageInput) { 
    currentPageNum = currentPageInput.value;
  }

  if (filterData || searchData) {
    // Update url
    if(updateURL){
      filterUpdateURL(filterData, searchData);

      // reseting current page
      if (currentPageInput) { 
        currentPageNum = 1;
        currentPageInput.value = 1;
      }
    }

    let activeTagsNotEmpty = filterAddingActiveTags(filterData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData)) || !filtersInitialLoad) {
      filtersInitialLoad = false;

      // // Scroll to filtering system
      // window.scrollTo({
      //   top: document.querySelector(".filters-pin").offsetTop,
      //   behavior: "smooth"
      // });

      // If there's an active search, open the search field
      if (searchData) {
        document.querySelector(".filters__search").classList.add("filters__search--open");
      }

      // Start filtering
      document.querySelector(".filtering-wrapper").classList.add("filtering");

      console.log(php_variables.posts);

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          php_variables.max_page = data.max_page;

          // hide load more button, if there are not enough posts for the second page
        
          if (loadmoreBtn) {
            if (data.max_page < 2) {
              loadmoreBtn.style.display = "none";
            } else {
              loadmoreBtn.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".posts.loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
            // Finish filtering
						document.querySelector(".filtering-wrapper").classList.remove("filtering");
          }

          setFilterTagsListeners();

          lazyLoadInstance.update();

          const effects = document.querySelectorAll(".effect");
          effectsInit(effects);
          
          // If there is more than one page that needs to be loaded
          if(currentPageNum && currentPageNum > 1 ){

            currentPageNum = currentPageNum > data.max_page ? data.max_page : currentPageNum;

            loadmoreLoadPostsMultiplePages(currentPageNum);
          }
        },
        error: function (data) {}
      });

    }else{
      //If filters are not set but there is more than one page to load
      if(currentPageNum && currentPageNum > 1){
        
        currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
        loadmoreLoadPostsMultiplePages(currentPageNum);
      }
    }
  }
};

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll(".filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function () {
      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      let filter_input = (document.querySelector(
        "input[name='" + filter_name + "'][value='" + filter_value + "']"
      ).checked = false);
      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts(true);
    });
  });
};

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filters__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      if (filterSearch && filterSearchInput) {
        filterSearchInput.value = "";
        filterSearch.classList.remove("filters__search--open");
      }

      // Remove all tags
      document.querySelector(".filters__tags").classList.remove("filters__tags--active");
      document.querySelector(".filters__activetags__tags").innerHTML = "";
      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter
      filterGetPosts(true);

      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });
  });
};

// Init Filter on posts pages
const filterInit = function () {

  const submitBtn = document.querySelector(".filters__apply");

  if (filterForm && filterForm.length) {
    // Get Posts based on Filter Form Data
    filterGetPosts(false);

    // Dropdown open & close
    filtersToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      filters.classList.remove("filters--searchopen");
      filters.classList.toggle("filters--dropdownopen");
    });

    document.addEventListener(
      "click",
      function(event) {
        // If user either clicks X button OR clicks outside the modal window, then close modal by calling closeModal()
        if (
          filters.classList.contains("filters--dropdownopen") &&
          !event.target.closest(".filters__dropdown")
        ) {
          filters.classList.toggle("filters--dropdownopen");
        }
      },
      false
    );

    // Search open & close
		if (filterSearchToggle){
      filterSearchToggle.addEventListener("click", function (e) {
        if (filterSearch.classList.contains("filters__search--open")) {
          filterSearch.classList.remove("filters__search--open");
        } else {
          filterSearch.classList.add("filters__search--open");
          filterSearchInput.focus();
        }
      });
		}

    // Filter on submit
    filterForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      // Call the filtering post function
      filterGetPosts(true);
      filters.classList.remove("filters--searchopen");
      filters.classList.remove("filters--dropdownopen");
    });

    const filterCheckboxes = filterForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        // Submit for on checkbox click
        filterGetPosts(true);
        filters.classList.toggle("filters--dropdownopen");
      });
    });

    // Remove tags on click
    setFilterTagsListeners();

    // Clear all
    filterSetupClearAll();
  }
};

filterInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects, context) {
  if (!effects) {
    return;
  }

  let viewportHeight = window.innerHeight;
  let viewportWidth = window.innerWidth;

  if (
    document.querySelector(".page-template-template-horizontal-scroll") &&
    viewportHeight > 500 &&
    viewportWidth > 700 &&
    !isTouchDevice
  ) {

    // Horizonal

    effects.forEach(function (val) {
      const waypoints = new Waypoint({
        element: val,
        handler: function (direction) {
          if (direction === "right") {
            val.classList.add("effect--ready");
          } else {
            val.classList.remove("effect--ready");
          }
        },
        offset: "90%",
        context: document.querySelector(".frame__main"),
        horizontal: true
      });
    });
  } else {

   // Vertical
    
    effects.forEach(function (val) {
      const waypoints = new Waypoint({
        element: val,
        handler: function (direction) {
          if (direction === "down") {
            val.classList.add("effect--ready");
          } else {
            val.classList.remove("effect--ready");
          }
        },
        context: context,
        offset: "90%"
      });
    });
  }
}; // effectsInit();
effectsInit(effects);

const effectsReset = function () {
	effects.forEach(function (val) {
		val.classList.remove("effect--ready");
	});

	Waypoint.destroyAll();

	scrollToContentInnit();

	effectsInit(effects);
};


/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll('.marquee');


const marquee__reset = function(el){

  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = viewportWidth * 1/2; 

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if(wrapElements[0].offsetWidth < minWidth){
    
    // Getting the orginal items
    const originalNumItems =  el.dataset.count ?  el.dataset.count : 1;

    let orginalTiles = '';

    const tiles = wrapElements[0].querySelectorAll('.marquee__tile');

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">'+tiles[index].innerHTML+"</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function(el) {

  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });

};

const marquee__init = function() {

  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function(){
      marqueeElements.forEach(function (el) {
        // Setup animation times
        marquee__resize(el);
      });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = viewportWidth * 1/2;

  marqueeElements.forEach(function (el) {
    
    // If it's a text marquee
    if (el.querySelector(".marquee__tile__text")) {
      const tile = el.querySelector(".marquee__tile");
      const textWidth = tile.offsetWidth;     

      const timesToRepeat =  Math.ceil(minWidth / textWidth);

      const textToRepeat = '<div class="marquee__tile">'+ tile.innerHTML +"</div>";

      for (let index = 1; index < timesToRepeat; index++) {
        el.innerHTML += textToRepeat;
      }
    }else{
      // If it's a logo marquee
      const tiles = el.querySelectorAll(".marquee__tile");
      const numTiles = tiles.length;
      const textWidth = tiles[0].offsetWidth * numTiles;
      const timesToRepeat = Math.ceil(minWidth / textWidth);
      
      const textToRepeat = el.innerHTML;

      for (let index = 1; index < timesToRepeat; index++) {
        el.innerHTML += textToRepeat;
      }

    }

    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>"+ el.innerHTML +"</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");

  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

/*  ==========================================================================
			Hero Slides
			========================================================================== */

const heroCarousel = document.querySelector(".pageheader--hero .owl-carousel");
const autoplayTimeout = 8000;

const heroStartProgressBar = function (event) {
  // apply keyframe animation
  const heroProgress = document.querySelector(".hero__progress");
  if (!heroProgress) {
    return;
  }

  heroProgress.style.width = "100%";
  heroProgress.style.transition = "width " + autoplayTimeout + "ms";
};

const heroResetProgressBar = function (event) {
  const heroProgress = document.querySelector(".hero__progress");
  if (!heroProgress) {
    return;
  }

  heroProgress.style.width = 0;
  heroProgress.style.transition = "width 0s";
};

const heroCarouselInit = function (heroCarousel) {
  if (!heroCarousel || heroCarousel.length <= 0) {
    return;
  }
  const slides = heroCarousel.querySelectorAll(".slide");
  if (!slides) {
    return;
  }

  // Optional data attribute settings
  const autoplay = true;
  const loop = true;
  const nav = false;
  const dots = true;
  const autoHeight = false;

  $(heroCarousel).on("initialized.owl.carousel", function (event) {
    setTimeout(function () {
      const dots = heroCarousel.querySelector(".owl-dots");

      document.querySelectorAll(".slide__dots").forEach(elem => {
        elem.style.width = dots.offsetWidth + "px";
      });
    }, 500);
  });

  $(heroCarousel).owlCarousel({
    autoplay: autoplay,
    autoplayTimeout: autoplayTimeout,
    loop: loop,
    nav: nav,
    dots: dots,
    items: 1,
    startPosition: slides.length,
    autoHeight: autoHeight,
    slideTransition: "cubic-bezier(.25,.75,.5,.85)",
    smartSpeed: 600,
    lazyLoad: true,
    onInitialized: heroStartProgressBar,
    onTranslate: heroResetProgressBar,
    onTranslated: heroStartProgressBar
  });

  $(heroCarousel).on("resized.owl.carousel", function (event) {
    // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
    setTimeout(function () {
      Waypoint.refreshAll();
    }, 500);
  });
};

heroCarouselInit(heroCarousel);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (!gridCarousels || gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const fade = elem.dataset.fade ? elem.dataset.fade : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).on("resized.owl.carousel", function (event) {
      $(elem).trigger("refresh.owl.carousel");
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });

    $(elem).on("refreshed.owl.carousel", function () {
      // console.log('has refreshed');
    });

    $(elem).on("initialized.owl.carousel", function (event) {
      // updating lazyload to capture the clone items in the carousel
      lazyLoadInstance.update();
    });

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      // rewind: true,
      dots: dots,
      items: 1,
      lazyLoad: true,
      navText: ["<i class='fal fa-arrow-left'></i>", "<i class='fal fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      animateOut: fade ? "fadeOut" : false,
      animateIn: fade ? "fadeIn" : false
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelectorAll(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";
let isMobnavOpen = false;

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.forEach(item =>
    item.addEventListener("click", function (e) {
      e.preventDefault();

      body.classList.toggle(mobnavOpenclass);
      isMobnavOpen = !isMobnavOpen;
    })
  );
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
		NAVIGATION - mobnav dropdowns
		========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__item__dropdownarrow");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();
      const mobnavTargetSection = e.target.closest(".sitenav__item");
      mobnavTargetSection.classList.toggle("sitenav__item--open");
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
		NAVIGATION - Horizonal page link transition
		========================================================================== */

const transitionlinks = document.querySelectorAll(".transitionlink");

const transitionlinksInit = function () {
  if (!transitionlinks) {
    return;
  }

  const pagetransition = document.querySelector(".pagetransition");

  transitionlinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      pagetransition.classList.add("pagetransition--in");

      var linkTo = this.getAttribute("href");
      setTimeout(function () {
        pagetransition.classList.add("pagetransition-out");
      }, 1200);

      setTimeout(function () {
        window.location.href = linkTo;
      }, 2200);
    });
  });
}; // mobnavlinksInit();
transitionlinksInit();

/*  ==========================================================================
		NAVIGATION - Sharebar: Single page Progress
		========================================================================== */

const mainContentWrap = document.querySelector("section.main");

const scrollProgressBar = function () {
  let winScroll = document.body.scrollTop || document.documentElement.scrollTop,
    height = mainContentWrap.offsetHei - document.documentElement.clientHeight,
    scrolled = (winScroll / height) * 100;

  document.querySelector(".progressbar").style.width = scrolled + "%";
};

const progressBarInnit = function () {
  const progressBar = document.querySelector(".progressbar");

  if (!progressBar) {
    return;
  }

  window.onscroll = function () {
    scrollProgressBar();
  };
};
progressBarInnit();

/*  ==========================================================================
		NAVIGATION - Sharebar: Waypoints
		========================================================================== */

const shareBarInnit = function () {
  const shareBar = document.querySelector(".sharebar");

  if (!shareBar) {
    return;
  }

  const shareBarBackBtn = shareBar.querySelector(".backbtn");

  shareBarBackBtn.addEventListener("click", function () {
    if (window.history.back.length === 0) {
      window.location = shareBarBackBtn.dataset.parent;
    }
  });

  const waypoints = new Waypoint({
    element: document.querySelector(".sitefooter"),
    handler: function (direction) {
      if (direction === "down") {
        shareBar.classList.add("unstick");
      } else {
        shareBar.classList.remove("unstick");
      }
    },
    offset: "90%"
  });
};

shareBarInnit();

/*  ==========================================================================
		NAVIGATION - Scroll to content
		========================================================================== */

const scrollToContentInnit = function () {
  const scrollToContent = document.querySelector(".pageheader__scrolltocontent");

  if (!scrollToContent) {
    return;
  }

  let viewportHeight = window.innerHeight;
  let viewportWidth = window.innerWidth;

  if (
    document.querySelector(".page-template-template-horizontal-scroll") &&
    viewportHeight > 500 &&
    viewportWidth > 700 &&
    !isTouchDevice
  ) {
    // It's horizontal scroll
    const waypoints = new Waypoint({
      element: document.querySelector(".pageheader"),
      handler: function (direction) {
        if (direction === "right") {
          scrollToContent.classList.add("right");
        } else {
          scrollToContent.classList.remove("right");
        }
      },
      offset: "-95%",
      context: document.querySelector(".frame__main"),
      horizontal: true
    });
  } else {
    // It's vertical
    const waypoints = new Waypoint({
      element: document.querySelector(".pageheader"),
      handler: function (direction) {
        if (direction === "down") {
          scrollToContent.classList.add("up");
        } else {
          scrollToContent.classList.remove("up");
        }
      },
      offset: "0%"
    });
  }

  scrollToContent.addEventListener("click", function () {
    const pageheader = document.querySelector(".pageheader").getBoundingClientRect();

    // If there is a pagenav on the page
    let pageheaderHeight = pageheader.height,
      pageheaderWidth = pageheader.width;

    if (document.querySelector(".page-template-template-horizontal-scroll")) {
      const scrollContainer = document.querySelector(".page-template-template-horizontal-scroll .frame__main");

      if (scrollToContent.classList.contains("right")) {
        scrollContainer.scroll({
          left: 0,
          behavior: "smooth"
        });
      } else {
        scrollContainer.scroll({
          left: window.scrollX + pageheaderWidth,
          behavior: "smooth"
        });
      }
    } else {
      if (scrollToContent.classList.contains("up")) {
        window.scroll({
          top: 0,
          behavior: "smooth"
        });
      } else {
        window.scroll({
          top: window.scrollY + pageheader.top + pageheaderHeight,
          behavior: "smooth"
        });
      }
    }
  });
};

scrollToContentInnit();

const scrollContainer = document.querySelector(".page-template-template-horizontal-scroll .frame__main");

let prevDeltaX = 0, prevDeltaY = 0;

const horizontalScrollScrollingAction = function(e) {
	// console.log( 'y:' + e.deltaY + '-- x:'  + e.deltaX);

	if(isMobnavOpen){ return; }
	
	e.preventDefault();
	if (prevDeltaY !== e.deltaY){
		scrollContainer.scrollLeft += e.deltaY;
	}else if(prevDeltaX !== e.deltaX){
		scrollContainer.scrollLeft += e.deltaX;
	}

	prevDeltaX = e.deltaX;
	prevDeltaY = e.deltaY;
};

	let initialviewportHeight = window.innerHeight;
  let initialviewportWidth = window.innerWidth;
	let isSmallScreen = false;

const horizontalScrollSetup = function(e) {

	window.addEventListener("unload", function(e) {
			localStorage.setItem("deltaX", scrollContainer.scrollLeft);
			console.log(scrollContainer.scrollLeft);
	});
	if(localStorage.deltaX) {
		scrollContainer.scrollLeft = localStorage.getItem("deltaX");
		console.log(localStorage.getItem("deltaX"));
	}

	let viewportHeight = window.innerHeight;
  let viewportWidth = window.innerWidth;

	if (viewportHeight > 500 && viewportWidth > 700 && !isTouchDevice) {
    // Add wheel event listener
    scrollContainer.addEventListener("wheel", horizontalScrollScrollingAction);
  } else {
    scrollContainer.removeEventListener("wheel", horizontalScrollScrollingAction);
  }

	if (
    (!isSmallScreen && (viewportHeight <= 500) || viewportWidth <= 700 || isTouchDevice )) {
    isSmallScreen = true;
    effectsReset();
  }else if(isSmallScreen && viewportHeight > 500 && viewportWidth > 700 && !isTouchDevice){
		isSmallScreen = false;
		 effectsReset();
	}

};

const horizontalScrollInit = function () {
	if(!scrollContainer){ return; }

	horizontalScrollSetup();

	const pagetransition = document.querySelector(".pagetransition");

	setTimeout(function () {
    pagetransition.classList.add("loaded");
  }, 100);
	window.addEventListener("resize", horizontalScrollSetup);

};

horizontalScrollInit();




const formBody = document.querySelector(".page-template-template-project-form");

/*  ==========================================================================
    PROJECT FORM  - Email format validation
    ========================================================================== */

const projectFormValidateEmail = function(email) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/.test(email)) {
    return true;
  }
  return false;
};

/*  ==========================================================================
    PROJECT FORM  - Step validation
    ========================================================================== */

const projectFormValidateStep = function(stepNum){

	const currentStep = document.getElementById('step'+stepNum);

	if (!currentStep){ return true; }

	let isValid = true;

	currentStep.querySelectorAll("input[required]").forEach(field => {
    if (!field.value || field.value === "") {
      field.classList.add("haserror");
      field.focus();
      isValid = false;
    } else if (field.type === "email") {
      let isEmailValid = projectFormValidateEmail(field.value);
      if (!isEmailValid) {
        field.classList.add("emailnotvalid");
        field.focus();
        isValid = false;
      }
    } else {
      if (field.classList.contains("haserror")) {
        field.classList.remove("haserror");
      }
    }
  });

	return isValid;
};

/*  ==========================================================================
    PROJECT FORM  - Go to step function
    ========================================================================== */

const projectFormGoToStep = function (step) {
  const nextStep = document.getElementById(step);
  const formSteps = formBody.querySelectorAll(".step");

  let currentStep = step.match(/\d+/)[0];

  // Validate current step
  let isValid = projectFormValidateStep(currentStep - 1);

  if (!isValid) {
    return;
  }

  // Hide the pageheader
  formBody.querySelector(".pageheader").classList.add("hide");

  // Look through steps to setup the navigation and hide previous steps
  formSteps.forEach((elem, index) => {
    let stepNum = index + 1;
    let navStep = document.querySelector(".projectform__navigation .navigation__step:nth-child(" + stepNum + ")");

    if (navStep) {
      if (stepNum <= currentStep) {
        navStep.classList.add("done");
      } else {
        navStep.classList.remove("done");
      }
    }

    elem.classList.add("hide");
  });

	// Show next step
  nextStep.classList.remove("hide");
};

/*  ==========================================================================
    PROJECT FORM  - Loading screen
    ========================================================================== */

const projectformSending = function () {
  const loading = document.getElementById("loading");
  const formSteps = formBody.querySelectorAll(".step");

	const navigation = formBody.querySelector(".projectform__navigation");
	navigation.style.pointerEvents = 'none';

  // Hide the pageheader
  formBody.querySelector(".pageheader").classList.add("hide");

  // Look through steps to setup the navigation and hide previous steps
  formSteps.forEach((elem, index) => {
    let stepNum = index + 1;
    let navStep = document.querySelector(".projectform__navigation .navigation__step:nth-child(" + stepNum + ")");

    navStep.classList.add("done");
    elem.classList.add("hide");
  });

  // Show next step
  loading.classList.remove("hide");
};

/*  ==========================================================================
    PROJECT FORM - Thank you
    ========================================================================== */

const projectformThankyou = function (form, returnedData) {
  const thankyou = document.getElementById("thankyou");
  const loading = document.getElementById("loading");

  console.log(returnedData);

  const overview = thankyou.querySelector(".overview__brief");
  const thankyouImages = [];
  const galleries = formBody.querySelectorAll(".galleryselector");
  galleries.forEach(gallery => {
    gallery.querySelectorAll(".galleryselector__option").forEach(option => {
      const input = option.querySelector("input"),
        img = option.querySelector(".galleryselector__img .mediaimg__img");
      if (input.checked) {
        thankyouImages.push(img.dataset.bg);
      }
    });
  });

  // Show next step
  thankyou.classList.remove("hide");
  loading.classList.add("hide");

  const thankyouImgWrap = thankyou.querySelector(".step__imagewrapper");
  thankyouImages.every((img, index) => {
    if (index < 5) {
      let imgElem = document.createElement("img");
			imgElem.src = img;
      thankyouImgWrap.appendChild(imgElem);
      return true;
    } else {
      return false;
    }
  });

	setTimeout(function(){
		thankyouImgWrap.classList.add('loaded');
	}, 250);
	
};

/*  ==========================================================================
    PROJECT FORM  - Init
    ========================================================================== */

const projectFormInit = function () {
  // if form doens't exists return
	if (!formBody) {
    return;
  }
  // Add event listener to start form
  const startformbtn = formBody.querySelector(".startform");

  if (startformbtn) {
    startformbtn.addEventListener("click", function (e) {
      e.preventDefault();

      formBody.classList.add("project-form--started");

      formBody.querySelector(".pageheader").classList.add("hide");

      projectFormGoToStep("step1");
    });
  }

  // Add eventlistener for the navigation between steps
  const stepbtns = formBody.querySelectorAll(".stepbtn");
  stepbtns.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      projectFormGoToStep(btn.dataset.step);
    });
  });

  // Add eventlistener for the persons name input to add to the Business details step heading
  // const nameInput = document.getElementById("projectform__name");
  // nameInput.addEventListener("input", event => {
  //   const personsName = event.target.value;
  //   const businessDetailsHeading = formBody.querySelector(".step--business-details .step__heading");

  //   if (personsName !== "" && !businessDetailsHeading.classList.contains("donotoverwrite")) {
  //     // If the heading doesn't have the class overwrite then update the text
  //     businessDetailsHeading.innerHTML = "Hi " + personsName;
  //   }
  // });

  // Add eventlistener to optout checkbox on number range elements
  const optoutCheckboxes = document.querySelectorAll(".step__optout input");

  optoutCheckboxes.forEach(checkbox => {
    checkbox.addEventListener("input", event => {
      const checkboxValue = event.target.value;
      const checkboxID = event.target.id;
      let checkboxstepNumber = checkboxID.split("__").pop();
      console.log(checkboxstepNumber);
      const step = document.getElementById("step" + checkboxstepNumber);
      step.classList.toggle("disabled");
    });
  });

  // PROJECT FORM SUBMIT
  const projectForm = document.getElementById("projectform");

  projectForm.addEventListener("submit", function (e) {
    e.preventDefault();

		// Get the last step number
    const currentStepID = document.querySelector(".step--person-details").id;
    let currentStepNumber = currentStepID.match(/\d+/)[0];

		// Validate last step
    let isValid = projectFormValidateStep(currentStepNumber);

    if (!isValid) {
      return;
    }

    // Show the 'loading' screen
    projectformSending();

    // Format form data
    let formData = $(this).serializeArray();

    formData.push(
      {
        name: "action",
        value: "projectform"
      },
      {
        name: "nonce",
        value: php_variables.nonce
      }
    );

    // Call the php function that sends the email
    $.ajax({
      url: php_variables.ajax_url,
      data: formData, // form data
      type: "POST",
      dataType: "json",
      success: function (data) {
        projectformThankyou($(this), data);
      },
      error: function (data) {}
    });
  });
}; // projectFormInit();

projectFormInit();

/*  ==========================================================================
    PROJECT FORM  - Range Value
    ========================================================================== */

const numberRange = document.querySelectorAll(".numberselector__range");

const numberSelectorSetValue = function(elem){

	const rangeInput = elem.querySelector('input[type="range"]'),
    rangeValue = elem.querySelector(".numberselector__value");

	const newValue = Number(((rangeInput.value - rangeInput.min) * 100) / (rangeInput.max - rangeInput.min)),
  			newPosition = 20 - newValue * 0.42;

  rangeValue.querySelector(".value").innerHTML = rangeInput.value;
  rangeValue.style.left = `calc(${newValue}% + (${newPosition}px))`;
	// rangeValue.style.left = `${newValue}%`;
};

const numberSelectorInit = function(){

	if(!numberRange){ return; }
	numberRange.forEach(elem => {
		numberSelectorSetValue(elem);

		elem.addEventListener("input", function(){
			numberSelectorSetValue(elem);
		});
	});

};

numberSelectorInit();




